/**
 *  @class
 *  @function FacetsToggle
 */
function updateRangeInputs(paramName) {
  const rawValues = JSON.parse(document.getElementById('min-' + paramName).dataset.values);
  const sortedValues = rawValues.map(Number)
                               .filter(value => !isNaN(value))
                               .sort((a, b) => a - b);
  
  // Update the min and max values based on sorted values
  const minValue = sortedValues[0];
  const maxValue = sortedValues[sortedValues.length - 1];

  // Set attributes for range inputs
  const minInput = document.getElementById('min-' + paramName);
  const maxInput = document.getElementById('max-' + paramName);
  // const minInput = document.getElementById('min-' + paramName);
  // const maxInput = document.getElementById('max-' + paramName);
  minInput.setAttribute('min', minValue);
  minInput.setAttribute('max', maxValue);
  maxInput.setAttribute('min', minValue);
  maxInput.setAttribute('max', maxValue);
  
  // Set the current values for range inputs
  minInput.value = minValue;  
  maxInput.value = maxValue;  
  document.getElementById('min-Filter-' + paramName).value = minValue;
  document.getElementById('max-Filter-' + paramName).value = maxValue;
  
  // Update data-values attributes with sorted values
  minInput.dataset.values = JSON.stringify(sortedValues);
  maxInput.dataset.values = JSON.stringify(sortedValues);
  document.getElementById('min-Filter-' + paramName).dataset.values = JSON.stringify(sortedValues);
  document.getElementById('max-Filter-' + paramName).dataset.values = JSON.stringify(sortedValues);
}
function facetChipLabel(anchor) {
  const clone = anchor.cloneNode(true);
  clone.querySelectorAll('span, svg').forEach(el => el.remove());
  return clone.textContent.replace(/\s+/g, ' ').trim();
}

function removeHeightFilterAnchors() {
  // One chip per centimetre would flood the bar. Collapse those into a
  // single range chip so "Fjern alle" is not the only child and stays visible.
  document.querySelectorAll('facet-remove').forEach(container => {
    const numeric = [];
    container.querySelectorAll('a.active-facets__button').forEach(anchor => {
      if (anchor.dataset.rangeChip === 'true') return;
      if (/^\d+$/.test(facetChipLabel(anchor))) numeric.push(anchor);
    });
    if (!numeric.length) return;

    const values = numeric.map(anchor => parseInt(facetChipLabel(anchor), 10));
    const min = Math.min(...values);
    const max = Math.max(...values);
    const icon = numeric[0].querySelector('span');
    const clearUrl = new URL(numeric[0].href, window.location.origin);
    ['filter.p.m.cus.hgt', 'filter.p.m.cus.hgt.gte', 'filter.p.m.cus.hgt.lte', 'filter.p.m.cus.dmt', 'filter.p.m.cus.dmt.gte', 'filter.p.m.cus.dmt.lte'].forEach(key => {
      clearUrl.searchParams.delete(key);
    });

    numeric.forEach(anchor => anchor.remove());

    const chip = document.createElement('a');
    chip.className = 'active-facets__button';
    chip.dataset.rangeChip = 'true';
    chip.href = `${clearUrl.pathname}${clearUrl.search}`;
    chip.appendChild(document.createTextNode(`${min} cm – ${max} cm`));
    if (icon) chip.appendChild(icon.cloneNode(true));
    chip.addEventListener('click', (event) => {
      event.preventDefault();
      const form = container.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      if (form) form.onActiveFilterClick(event);
    });
    const clearAll = container.querySelector('.active-facets__button-remove');
    container.insertBefore(chip, clearAll);
  });
}
function updateProductDisplay(minSliderValue, maxSliderValue) {
const productItems = document.querySelectorAll('#product-grid .column');
let itemsPerPage =  productsPerPage; 
// Filter products based on slider values
const filteredItems = Array.from(productItems).filter(item => {
    const filter = parseFloat(item.dataset.height);
    return filter >= minSliderValue && filter <= maxSliderValue;
});
// const filteredItems = Array.from(productItems).filter(item => {
//     const height = parseFloat(item.dataset.height);
//     const dimension = parseFloat(item.dataset.dimension);
//     return height >= minHeight && height <= maxHeight && dimension >= minDimension && dimension <= maxDimension;

// Calculate total pages based on filtered items
const totalPages = Math.ceil(filteredItems.length / itemsPerPage);

// Hide all products first
productItems.forEach(item => item.style.display = 'none');

// Show only the filtered products for the current page
filteredItems.forEach(item => {
    item.style.display = ''; // Show the product
});


}


function updateRangeSliderValues(paramName, filterValues) {

if (paramName.includes('min-Filter')) {
    const minSlider = document.getElementById(paramName.replace('-Filter', ''));
    const minRangeSlider = document.getElementById(paramName);
    minSlider.value = minRangeSlider.value;
} else {
    const maxSlider = document.getElementById(paramName.replace('-Filter', ''));
    const maxRangeSlider = document.getElementById(paramName);
    maxSlider.value = maxRangeSlider.value;
}

// Clean up paramName for further use
paramName = paramName.replace('min-Filter-', '').replace('max-Filter-', '');

// Call updateSliderValues with the modified parameter name
updateSliderValues(paramName, filterValues);
updateUrlParams(paramName, filterValues);
}

// Function to handle slider value updates
function updateSliders(minSlider, maxSlider, selectedRange, rangeSelected, minRangeSlider, maxRangeSlider) {
// Ensure minSlider value does not exceed maxSlider value
if (parseFloat(minSlider.value) > parseFloat(maxSlider.value)) {
    const selectedMaxSlider = maxSlider.value;
    maxSlider.value = minSlider.value;
    minSlider.value = selectedMaxSlider;
}

// Ensure maxSlider value does not fall below minSlider value
if (parseFloat(maxSlider.value) < parseFloat(minSlider.value)) {
    const selectedMaxSlider = maxSlider.value;
    maxSlider.value = minSlider.value;
    minSlider.value = selectedMaxSlider;
}

// Update min and max range sliders
if (minRangeSlider) {
    minRangeSlider.value = minSlider.value;
}
if (maxRangeSlider) {
    maxRangeSlider.value = maxSlider.value;
}

if (selectedRange) {
    selectedRange.textContent = `${minSlider.value} cm - ${maxSlider.value} cm`;
}

const leftPercentage = ((minSlider.value - minSlider.min) / (minSlider.max - minSlider.min)) * 100;
const rightPercentage = ((maxSlider.value - minSlider.min) / (minSlider.max - minSlider.min)) * 100;

if (rangeSelected) {
    rangeSelected.style.left = `${leftPercentage}%`;
    rangeSelected.style.right = `${100 - rightPercentage}%`;
}
}

function updateSliderValues(paramName, filterValues) {
// Check if paramName includes 'mb' and replace 'mb-' prefix if it does
const useMbSliders = paramName.includes('mb');
const modifiedParamName = useMbSliders ? paramName.replace('mb-', '') : paramName;

// Select sliders based on the condition
const minSlider = useMbSliders ? document.getElementById(`min-mb-${modifiedParamName}`) : document.getElementById(`min-${modifiedParamName}`);
const maxSlider = useMbSliders ? document.getElementById(`max-mb-${modifiedParamName}`) : document.getElementById(`max-${modifiedParamName}`);
const selectedRange = useMbSliders ? document.getElementById(`selected-mb-${modifiedParamName}`) : document.getElementById(`selected-${modifiedParamName}`);
const rangeSelected = useMbSliders ? document.getElementById(`range-mb-${modifiedParamName}`) : document.getElementById(`range-${modifiedParamName}`);
const minRangeSlider = useMbSliders ? document.getElementById(`min-Filter-mb-${modifiedParamName}`) : document.getElementById(`min-Filter-${modifiedParamName}`);
const maxRangeSlider = useMbSliders ? document.getElementById(`max-Filter-mb-${modifiedParamName}`) : document.getElementById(`max-Filter-${modifiedParamName}`);

// Update sliders
updateSliders(minSlider, maxSlider, selectedRange, rangeSelected, minRangeSlider, maxRangeSlider);


}


function updateUrlParams(paramName, filterValues) {
const useMbSliders = paramName.includes('mb');
const minSlider = useMbSliders ? document.getElementById(`min-${paramName}`) : document.getElementById(`min-${paramName}`);
const maxSlider = useMbSliders ? document.getElementById(`max-${paramName}`) : document.getElementById(`max-${paramName}`);

// Get the current values from sliders
const minValue = parseInt(minSlider.value);
const maxValue = parseInt(maxSlider.value);


const queryValues = [];
// Check ranges for the selected sliders
// if (paramName.includes('filter.p.m.cus.hgt')) {
        const queryValue = `${minValue} - ${maxValue}`;
        const formattedQueryValue = queryValue.replace(/ - /g, '+-+');
if (minValue == minSlider.min && maxValue == maxSlider.max ) {
}else {
    queryValues.push(`${paramName}=${formattedQueryValue}`); // Concatenate min and max values with a separator
// } else {
// // Process filter values
// const parsedFilterValues = JSON.parse(filterValues);
// const validRanges = parsedFilterValues.map(value => {
//     const [min, max] = value.split(' - ').map(v => parseInt(v));
//     return { min, max };
// });
// validRanges.forEach(range => {
//     if (range.max >= minValue && range.min <= maxValue) {
//         const queryValue = `${range.min} - ${range.max} cm`;
//         const formattedQueryValue = queryValue.replace(/ - /g, '+-+').replace(/ cm/g, '+cm');
//         queryValues.push(`${paramName}=${formattedQueryValue}`);
//     }
// });
// }

// Construct final query string
const finalQueryString = queryValues.join('&');
} 
// Update the URL without reloading the page
updateUrlParam(paramName, queryValues.length ? queryValues : null);
}

// Function to update URL parameters
function updateUrlParam(paramName, values) {
let currentUrl = new URL(window.location.href);

// Clear existing parameters
currentUrl.searchParams.delete(paramName);

if (values) {
    values.forEach(value => {
        const separator = currentUrl.search ? '&' : '?';
        currentUrl.search += `${separator}${value}`;
    });
}

// Push the new URL state
history.pushState(null, '', currentUrl.toString());
}

function setRangeFromUrl() {
const currentUrl = new URL(window.location.href);
const filterMap = {};

// Collect filter parameters
for (const [key, value] of currentUrl.searchParams.entries()) {
    if (key === 'filter.p.m.cus.hgt' || key === 'filter.p.m.cus.dmt' || key === 'mb-filter.p.m.cus.hgt' || key === 'mb-filter.p.m.cus.dmt') {
        // Directly store the height and dmt filter values
        filterMap[key] = [value];
    }
}

const minMaxMap = {};

['filter.p.m.cus.hgt', 'filter.p.m.cus.dmt', 'mb-filter.p.m.cus.hgt', 'mb-filter.p.m.cus.dmt'].forEach(key => {
    const filterParam = filterMap[key];
    if (filterParam) {
        const values = filterParam[0].split(' - ');
        if (values.length === 2) {
            const minValue = parseFloat(values[0]);
            const maxValue = parseFloat(values[1]);

            if (!isNaN(minValue) && !isNaN(maxValue)) {
                minMaxMap[key] = { min: minValue, max: maxValue };
            } else {
                console.warn(`Invalid min/max values from parameter: ${filterParam[0]}`);
            }
        }
    }
});

// Cache DOM elements to reduce lookups
const elements = {};
for (const key in minMaxMap) {
    elements[`min-${key}`] = document.getElementById(`min-${key}`);
    elements[`max-${key}`] = document.getElementById(`max-${key}`);
    elements[`selected-${key}`] = document.getElementById(`selected-${key}`);
    elements[`range-${key}`] = document.getElementById(`range-${key}`);
}

// Set sliders and range display
for (const key in minMaxMap) {
    const { min, max } = minMaxMap[key];
    const minSlider = elements[`min-${key}`];
    const maxSlider = elements[`max-${key}`];
    const selectedRange = elements[`selected-${key}`];
    const rangeSelected = elements[`range-${key}`];
    const minRangeSlider = document.getElementById(`min-Filter-${key}`);
    const maxRangeSlider = document.getElementById(`max-Filter-${key}`);

    if (minSlider) minSlider.value = min;
    if (maxSlider) maxSlider.value = max;

    if (selectedRange) {
        selectedRange.textContent = `${minSlider.value} cm - ${maxSlider.value} cm`;
        maxRangeSlider.value = max;
        minRangeSlider.value = min;
    }

    // Calculate percentages for the range slider
    const sliderMin = parseFloat(minSlider.min);
    const sliderMax = parseFloat(maxSlider.max);
    const leftPercentage = ((min - sliderMin) / (sliderMax - sliderMin)) * 100;
    const rightPercentage = ((max - sliderMin) / (sliderMax - sliderMin)) * 100;

    if (rangeSelected) {
        rangeSelected.style.left = `${leftPercentage}%`;
        rangeSelected.style.right = `${100 - rightPercentage}%`;
    }
}
}


removeHeightFilterAnchors();
document.addEventListener('DOMContentLoaded', updateRangeInputs('filter.p.m.cus.hgt'));
// document.addEventListener('DOMContentLoaded', updateRangeInputs('filter.p.m.cus.dmt'));
document.addEventListener('DOMContentLoaded', updateRangeInputs('mb-filter.p.m.cus.hgt'));
// document.addEventListener('DOMContentLoaded', updateRangeInputs('mb-filter.p.m.cus.dmt'));
document.addEventListener('DOMContentLoaded', setRangeFromUrl);
class FacetsToggle {
constructor() {
this.container = document.getElementById('Facet-Drawer');
let button = document.getElementById('Facets-Toggle');

// Add functionality to buttons
if (button) {
  button.addEventListener('click', (e) => {
//     e.preventDefault();
//     document.getElementsByTagName("body")[0].classList.toggle('open-cc');
//    this.container.classList.toggle('active');
  });
}
}
}


class FacetFiltersForm extends HTMLElement {
constructor() {
super();
this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

this.debouncedOnSubmit = debounce((event) => {
  this.onSubmitHandler(event);
}, 500);

const form = this.querySelector('form');
form.addEventListener('input', this.debouncedOnSubmit.bind(this));
    
// Add change event listener for checkboxes specifically
form.addEventListener('change', (event) => {
  if (event.target.type === 'checkbox') {
    this.onSubmitHandler(event);
  }
});
}

static setListeners() {
const onHistoryChange = (event) => {
  const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
  if (searchParams === FacetFiltersForm.searchParamsPrev) return;
  FacetFiltersForm.renderPage(searchParams, null, false);
};
window.addEventListener('popstate', onHistoryChange);
}

static toggleActiveFacets(disable = true) {
document.querySelectorAll('.js-facet-remove').forEach((element) => {
  element.classList.toggle('disabled', disable);
});
}

static renderPage(searchParams, event, updateURLHash = true) {
                        
    const oldSearchParams = searchParams;                                    
FacetFiltersForm.searchParamsPrev = searchParams;
const sections = FacetFiltersForm.getSections();
const container = document.getElementsByClassName('thb-filter-count');
document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

for (var item of container) {
  item.classList.add('loading');
}
const heightFilterPattern = /filter\.p\.m\.cus\.hgt=(\d+)\+\-\+(\d+)/;
const diameterFilterPattern = /filter\.p\.m\.cus\.dmt=(\d+)\+\-\+(\d+)/;
const heightFilterMatch = searchParams.match(heightFilterPattern);
const diameterFilterMatch = searchParams.match(diameterFilterPattern);

function expandRange(match, type) {
const startValue = parseInt(match[1], 10);
const endValue = parseInt(match[2], 10);
const slug = type === 'height' ? 'hgt' : 'dmt';
let dataValues =
  event && event.target && event.target.getAttribute
    ? event.target.getAttribute('data-values')
    : null;
if (!dataValues) {
  const fallbackMin =
    document.getElementById(`min-filter.p.m.cus.${slug}`) ||
    document.getElementById(`min-mb-filter.p.m.cus.${slug}`);
  dataValues = fallbackMin && fallbackMin.getAttribute('data-values');
}
const allowedValues = (dataValues ? JSON.parse(dataValues) : []).map((v) => Number(v));

// Build params safely to avoid malformed query strings.
const newSearchParams = new URLSearchParams(searchParams);
const filterKey = `filter.p.m.cus.${slug}`;
newSearchParams.delete(filterKey);

for (let value = startValue; value <= endValue; value++) {
  if (allowedValues.includes(value)) {
    newSearchParams.append(filterKey, String(value));
  }
}

return newSearchParams.toString();
}

// Check for height filter and expand range
if (heightFilterMatch) {
searchParams = expandRange(heightFilterMatch, 'height');
}

// Check for diameter filter and expand range
if (diameterFilterMatch) {
searchParams = expandRange(diameterFilterMatch, 'diameter');
}

sections.forEach((section) => {
  const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
  const filterDataUrl = element => element.url === url;

  if (FacetFiltersForm.filterData.some(filterDataUrl)) {
    FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
  } else {
    FacetFiltersForm.renderSectionFromFetch(url, event);
  }
});
if (updateURLHash) FacetFiltersForm.updateURLHash(oldSearchParams);
}

static renderSectionFromFetch(url, event) {
fetch(url)
  .then(response => response.text())
  .then((responseText) => {
    const html = responseText;
    FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
      html,
      url
    }];
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);

    new FacetsToggle();

  });
}

static renderSectionFromCache(filterDataUrl, event) {
const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
FacetFiltersForm.renderFilters(html, event);
FacetFiltersForm.renderProductGridContainer(html);
FacetFiltersForm.renderProductCount(html);
}

static renderProductGridContainer(html) {

document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
updateRangeInputs('filter.p.m.cus.hgt'); 
// updateRangeInputs('filter.p.m.cus.dmt'); 
 updateRangeInputs('mb-filter.p.m.cus.hgt'); 
// updateRangeInputs('mb-filter.p.m.cus.dmt'); 
setRangeFromUrl(); 
removeHeightFilterAnchors();
}

static renderProductCount(html) {
const countHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
const container = document.getElementsByClassName('thb-filter-count');

if (countHtml) {
  for (var item of container) {
    item.innerHTML = countHtml.innerHTML;
    item.classList.remove('loading');
  }
}

}

static renderFilters(html, event) {
const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
const facetDetailsElements =
  parsedHTML.querySelectorAll('#FacetFiltersForm collapsible-row, #FacetFiltersFormMobile collapsible-row');
const matchesIndex = (element) => {
  const jsFilter = event ? event.target.closest('collapsible-row') : undefined;
  return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
};
const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

facetsToRender.forEach((element) => {
  // document.querySelector(`collapsible-row[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
});

// FacetFiltersForm.renderActiveFacets(parsedHTML);
// FacetFiltersForm.renderAdditionalElements(parsedHTML);

// if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('collapsible-row'));
}

static renderActiveFacets(html) {
const activeFacetElementSelectors = ['.active-facets'];

activeFacetElementSelectors.forEach((selector) => {
  const activeFacetsElement = html.querySelector(selector);
  if (!activeFacetsElement) return;
  document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
});

FacetFiltersForm.toggleActiveFacets(false);
}

static renderAdditionalElements(html) {
const mobileElementSelectors = ['.mobile-filter-count'];

mobileElementSelectors.forEach((selector) => {
  if (!html.querySelector(selector)) return;
  document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
});

}

static renderCounts(source, target) {
const targetElement = target.querySelector('.facets__selected');
const sourceElement = source.querySelector('.facets__selected');

if (sourceElement && targetElement) {
  target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
}
}

static updateURLHash(searchParams) {
history.pushState({
  searchParams
}, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
}

static getSections() {
return [
  {
    section: document.getElementById('product-grid').dataset.id,
  }];
}

onSubmitHandler(event) {
event.preventDefault();
if (event.target.id.includes('-Filter-') ) {
  updateRangeSliderValues(event.target.id, event.target.dataset.values)
}
const form = event.target.closest('form');
const formData = new FormData(form);
const searchParams = new URLSearchParams(formData);
const currentUrl = window.location.href;
const paramsIndex = currentUrl.indexOf('?');
const currentParams = paramsIndex > -1 ? new URLSearchParams(currentUrl.substring(paramsIndex)) : new URLSearchParams();

// Get all existing filter parameters and store unique values
const existingFilters = {};
for (const [key, value] of currentParams) {
  if (key.includes('filter.')) {
    if (!existingFilters[key]) {
      existingFilters[key] = new Set();
    }
    existingFilters[key].add(value);
  }
}

// Get the checkbox that triggered the event
const checkbox = event.target.type === 'checkbox' ? event.target : event.target.querySelector('input[type="checkbox"]');
const isUnchecking = checkbox && !checkbox.checked;

// If we're unchecking a checkbox, we need to handle it specially
if (isUnchecking && checkbox) {
  const checkboxName = checkbox.name;
  const checkboxValue = checkbox.value;
  
  // Remove this specific value from existing filters
  if (existingFilters[checkboxName]) {
    existingFilters[checkboxName].delete(checkboxValue);
  }
  
  // Clear all existing values for this filter and add back the remaining ones
  currentParams.delete(checkboxName);
  if (existingFilters[checkboxName] && existingFilters[checkboxName].size > 0) {
    existingFilters[checkboxName].forEach(v => currentParams.append(checkboxName, v));
  }
}

// Handle new form data (for checked checkboxes and other inputs)
for (const [key, value] of searchParams) {
  if (key === 'filter.v.price.gte' || key === 'filter.v.price.lte') {
    const priceValue = parseFloat(value).toFixed(2);
    if (priceValue !== "0.00" && priceValue !== parseFloat(document.querySelector('.price_slider').dataset.max).toFixed(2)) {
      currentParams.set(key, priceValue);
    }
  } else if (key.includes('filter.')) {
    // For filter parameters, add the value (this handles checked checkboxes)
    const existingValues = existingFilters[key] || new Set();
    existingValues.add(value);
    
    // Clear existing values for this filter and add back all values
    currentParams.delete(key);
    existingValues.forEach(v => currentParams.append(key, v));
  } else {
    currentParams.set(key, value);
  }
}

// Only remove min price if it's exactly 0.00
if (searchParams.get('filter.v.price.gte') === "0.00") {
  currentParams.delete('filter.v.price.gte');
}

// Only remove max price if it matches the slider max exactly (comparing with 2 decimal places)
if (document.querySelector('.price_slider')) {
  const sliderMax = parseFloat(document.querySelector('.price_slider').dataset.max).toFixed(2);
  const currentMax = searchParams.get('filter.v.price.lte');
  if (currentMax && parseFloat(currentMax).toFixed(2) === sliderMax) {
    currentParams.delete('filter.v.price.lte');
  }
}

FacetFiltersForm.renderPage(currentParams.toString(), event);
}

onActiveFilterClick(event) {
event.preventDefault();
FacetFiltersForm.toggleActiveFacets();
const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
FacetFiltersForm.renderPage(url);
}
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();


class FacetRemove extends HTMLElement {
constructor() {
super();
this.querySelectorAll('a').forEach((item) => {
  item.addEventListener('click', (event) => {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  });
});
}
}

customElements.define('facet-remove', FacetRemove);

/**
*  @class
*  @function PriceSlider
*/
class PriceSlider extends HTMLElement {

constructor() {
super();
}
connectedCallback() {
let slider = this.querySelector('.price_slider'),
  amounts = this.querySelector('.price_slider_amount'),
  args = {
    start: [parseFloat(slider.dataset.minValue || 0), parseFloat(slider.dataset.maxValue || slider.dataset.max)],
    connect: true,
    step: 10,
    range: {
      'min': 0,
      'max': parseFloat(slider.dataset.max)
    }
  },
  event = new CustomEvent('input'),
  form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');

if (slider.classList.contains('noUi-target')) {
  slider.noUiSlider.destroy();
}
noUiSlider.create(slider, args);

slider.noUiSlider.on('update', function (values) {
  amounts.querySelector('.field__input_min').value = values[0];
  amounts.querySelector('.field__input_max').value = values[1];
});
slider.noUiSlider.on('change', function (values) {
  form.querySelector('form').dispatchEvent(event);
});
}
}
customElements.define('price-slider', PriceSlider);

window.addEventListener('load', () => {
new FacetsToggle();
});

document.addEventListener('DOMContentLoaded', function() {
document.addEventListener('click', function(event) {
    // Check if the clicked target is the Facets-Toggle
    if (event.target.closest('#Facets-Toggle')) {
        event.preventDefault(); // Prevent the default anchor behavior
        var facetDrawer = document.getElementById('Facet-Drawer');
        if (facetDrawer) {
            facetDrawer.classList.add('active'); 
        }
    } else {
        // Stop propagation and do nothing in else
        event.stopPropagation();
    }
});
});






function updateHeightFilterFromUrl() {
  const url = new URL(window.location.href);
  const searchParams = url.searchParams;
  
  const heightFilterValues = Array.from(searchParams.entries())
    .filter(([key, value]) => key === 'filter.p.m.cus.hgt')
    .map(([_, value]) => value);
  
  if (heightFilterValues && heightFilterValues.length > 0) {
    let minValue, maxValue;
    
    if (heightFilterValues.length === 1 && heightFilterValues[0].includes('+-+')) {
      const [min, max] = heightFilterValues[0].split('+-+').map(value => parseInt(value));
      minValue = min;
      maxValue = max;
    } else {
      const numericValues = heightFilterValues
        .filter(value => /^\d+$/.test(value))
        .map(value => parseInt(value))
        .filter(value => !isNaN(value));
      
      if (numericValues.length > 0) {
        minValue = Math.min(...numericValues);
        maxValue = Math.max(...numericValues);
      }
    }
    
    if (minValue !== undefined && maxValue !== undefined) {
      const minInput = document.getElementById('min-Filter-filter.p.m.cus.hgt');
      const maxInput = document.getElementById('max-Filter-filter.p.m.cus.hgt');
      
      const minSlider = document.getElementById('min-filter.p.m.cus.hgt');
      const maxSlider = document.getElementById('max-filter.p.m.cus.hgt');
      
      const selectedRange = document.getElementById('selected-filter.p.m.cus.hgt');
      const rangeSelected = document.getElementById('range-filter.p.m.cus.hgt');
      
      if (minInput && maxInput) {
        minInput.value = minValue;
        maxInput.value = maxValue;
        
        if (minSlider && maxSlider) {
          minSlider.value = minValue;
          maxSlider.value = maxValue;
          
          if (selectedRange) {
            selectedRange.textContent = `${minValue} - ${maxValue}`;
          }
          
          if (rangeSelected) {
            const sliderMin = parseFloat(minSlider.min);
            const sliderMax = parseFloat(maxSlider.max);
            const leftPercentage = ((minValue - sliderMin) / (sliderMax - sliderMin)) * 100;
            const rightPercentage = ((maxValue - sliderMin) / (sliderMax - sliderMin)) * 100;
            rangeSelected.style.left = `${leftPercentage}%`;
            rangeSelected.style.right = `${100 - rightPercentage}%`;
          }
        }
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  updateHeightFilterFromUrl();
});


